import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import {
  Conditional,
  CustomStyledLabel,
  RequestServiceDateTabs
} from '@cat-ecom/pcc-components';
import { REQUEST_SERVICE_FORM_ATTRIBUTES } from '../constant';
import { useFormContext } from 'react-hook-form';
import RequestEquipmentServiceFirstAvailableWrapper from '../request-equipment-service-first-available';
import RequestEquipmentServiceCalenderWrapper from '../request-equipment-service-calender-wrapper';

const RequestEquipmentServicePreferredDate = ({ tabs, isMobile }) => {
  const t = useTranslations();
  const { watch } = useFormContext();
  const preferredType = watch('preferredDateTime.type');
  const isASAPView =
    preferredType === REQUEST_SERVICE_FORM_ATTRIBUTES.prefDateType.asap;
  return (
    <>
      <CatHeading className="pb-3 mb-2" variant="label">
        <CustomStyledLabel>{t('REQUEST_SERVICE_DATE')}</CustomStyledLabel>
      </CatHeading>
      <div className="mt-4 mb-md-3 mb-4 d-flex justify-content-center">
        <RequestServiceDateTabs tabs={tabs} />
      </div>
      <Conditional
        test={isASAPView}
        fallback={
          <RequestEquipmentServiceCalenderWrapper isMobile={isMobile} />
        }
      >
        <RequestEquipmentServiceFirstAvailableWrapper />
      </Conditional>
    </>
  );
};

export default RequestEquipmentServicePreferredDate;
